import { useState } from "react";

// ─── DATA ───────────────────────────────────────────────────────────────────

const TICKER_ITEMS = [
  ["💡", "Adjustable Lamps"], ["🔐", "Secure Lockers"], ["📚", "200+ Prep Books"],
  ["🧠", "Pomodoro Timers"], ["🎧", "Noise Cancelling"], ["🕐", "24/7 Access"],
  ["📷", "CCTV Security"], ["🥤", "Snacks & Water"], ["🖨️", "Print/Scan/Copy"],
  ["📱", "Mobile App"], ["🤖", "AI Model"], ["🛜", "100 Mbps WiFi"],
  ["💳", "Card · Cash · D17"], ["🧊", "Fridge & Kitchen"], ["🪑", "Ergonomic Chairs"],
  ["🌳", "Open Area"], ["📐", "Borrow Equipment"], ["🔌", "Charging Station"],["🧃", "Buvette"],["🗣️", "Discussion Room"],["♻️", "Waste Tri"],
];

const FEATURES = [
  { icon: "🛜", name: "100 Mbps Internet", desc: "Fast, stable dedicated fiber — perfect for research, lectures, or video calls." },
  { icon: "🕐", name: "Open 24/7", desc: "Study on your schedule. Our doors never close, ever." , cyan: true },
  { icon: "🧠", name: "Pomodoro Timers", desc: "25-minute deep-focus cycles built into every desk for peak productivity."},
  { icon: "💡", name: "Adjustable Individual Lamps", desc: "Toggle between bright white, soft yellow, or warm ambient — each desk independently controlled so you never disturb your neighbor." },
  { icon: "📚", name: "200+ Prep Books", desc: "Med, engineering, law and more. Browse freely, no checkout." },
  { stat: "57", label: "workstations across 4 rooms", dark: true },
  { icon: "🗣️", name: "Discussion Room", desc: "A brand new phonebooth-style pod for up to 4 people — perfect for group work, calls, or collaboration without breaking the silence elsewhere." },
  { icon: "🔒", name: "Secure Lockers", desc: "Lock up your belongings and focus without worry." },
  { icon: "🔋", name: "Powerbanks", desc: "Borrow a powerbank and keep your devices charged without leaving your seat." },
{ icon: "🧃", name: "Buvette", desc: "Grab a coffee, juice, energy drink or snack from our in-house buvette — no need to step outside." },
  { icon: "🖨️", name: "Print / Scan / Copy", desc: "All-in-one station on-site. No need to leave." },
  { icon: "🧊", name: "Kitchen Access", desc: "Fridge, microwave, water fountain, cutlery — fully equipped for long sessions." },
  { icon: "💳", name: "Flexible Payments", desc: "Card · Cash · D17 · Konnect · Flouci · Pluxee" },
  { icon: "📷", name: "CCTV Security", desc: "Full coverage so you always feel safe." },
  { icon: "🤖", name: "AI Internal Model", desc: "Smart personalization and productivity suggestions built into the platform." },
];

const ROOMS = [
  {
    icon: "🌌", name: "OpenSpace", capacity: 22,
    bg: "linear-gradient(135deg,#0f2027 0%,#203a43 50%,#2c5364 100%)",
    desc: "Our largest and most welcoming zone. Individual desks, relaxed atmosphere — open to all students.",
    tags: [{ label: "No talking", red: true }, { label: "No phone calls", red: true }, { label: "All students welcome" }, { label: "Individual desks" }],
  },
  {
    icon: "🔇", name: "Silent Room", capacity: 15,
    bg: "linear-gradient(135deg,#0a0a0a 0%,#1a1a2e 100%)",
    desc: "Library-grade silence. Pen and paper territory. University students only — no keyboards or mice.",
    tags: [{ label: "Zero talking", red: true }, { label: "Uni students only", red: true }, { label: "No keyboard/mouse", red: true }],
  },
  {
    icon: "🧠", name: "Focus Room", capacity: 9,
    bg: "linear-gradient(135deg,#0d0d0d 0%,#1a0a0a 100%)",
    desc: "Maximum depth. No food, no noise, no movement. The most productive — and most restrictive — room we have.",
    tags: [{ label: "No food/drinks", red: true }, { label: "No movement", red: true }, { label: "Uni only", red: true }, { label: "No keyboard/mouse", red: true }],
  },
  {
    icon: "🚬", name: "Smoking Room", capacity: 7,
    bg: "linear-gradient(135deg,#1a0f00 0%,#3d2200 100%)",
    desc: "A dedicated space for smokers, fully separate from all study areas to keep the air fresh everywhere else.",
    tags: [{ label: "Smokers only", red: true }, { label: "No vaping", red: true }, { label: "Door remains open" }],
  },
];

const DIGITAL_FEATURES = [
  { icon: "🤖", title: "AI Productivity Model", desc: "Personalized suggestions trained on how students actually work." },
  { icon: "📅", title: "Smart Booking System", desc: "Reserve your seat and manage sessions from your phone, instantly." },
  { icon: "📊", title: "Study Analytics", desc: "Track streaks, hours logged, and focus patterns over time." },
  { icon: "🏆", title: "Loyalty & Rewards", desc: "Earn points for every hour. Redeem for free sessions and perks." },
];

const SDGS = [
  { num: "04", title: "Quality Education", desc: "Quiet, equipped, and accessible to all students regardless of background." },
  { num: "09", title: "Innovation & Infrastructure", desc: "Investing in digital tools and modern amenities to keep learning tech-forward." },
  { num: "11", title: "Sustainable Cities", desc: "Shared learning hubs make cities more inclusive and community-resilient." },
  { num: "13", title: "Climate Action", desc: "Shared spaces reduce energy waste. We promote digital-first, minimal-print habits." },
];

const PRICING = {
  daily: [
    { duration: "2 hours", price: "4.5 TND" }, { duration: "3 hours", price: "6 TND" },
    { duration: "5 hours", price: "7 TND" }, { duration: "8 hours", price: "10 TND" },
    { duration: "12 hours", price: "13 TND" },
  ],
  weekly: [
    { duration: "5 h / day", price: "50 TND" }, { duration: "8 h / day", price: "60 TND" },
    { duration: "12 h / day", price: "70 TND" },
  ],
  monthly: [
    { duration: "5 h / day", price: "90 TND" }, { duration: "8 h / day", price: "115 TND" },
    { duration: "12 h / day", price: "145 TND" },
  ],
};

const REVIEWS = [
  { name: "Yasmine Abbes", comment: "Un espace calme et motivant, une atmosphère agréable adéquate pour un travail sérieux. C'est l'endroit parfait pour une journée productive." },
  { name: "malak bellil", comment: "If you are looking for comfort, safety, quietness & motivation to study/work, WeStudy is certainly your go-to. It feels like a 'studying-family'! Warning: You'll turn into a nerd in no time 😉" },
  { name: "Mustafa Stoufa", comment: "A very amazing place calm and cozy which creates the perfect environment for a perfect study session." },
  { name: "AMAL CHEMAKH", comment: "C'est le meilleur espace pour étudier, une équipe très professionnelle et aimable ❤️" },
  { name: "Ryan Aouicha", comment: "Environmentally cautious, focus oriented, interesting design, cheap service, tame staff. The best co-studying space I've ever been to." },
  { name: "Yeamina Smei", comment: "C'est le seul endroit où je peux travailler avec concentration et me sentir à l'aise grâce aux meilleures conditions." },
  { name: "Youssef Manai", comment: "Un endroit très étonnant, calme et cosy qui crée l'environnement parfait pour une séance d'étude parfaite. Merci" },
  { name: "soumaya chebbi", comment: "The space is calm, clean, and very organized, perfect for staying focused." },
  { name: "سيد أبو زيد", comment: "WeStudy était ma 2ème maison depuis 2021 — c'est là où je peux fuir les distractions pour me concentrer." },
  { name: "Hané Dkhili", comment: "Cool environment, well organized and encouraging ✨" },
  { name: "Baha Smaoui", comment: "Clean, Organized, Calm" },
  { name: "kadri mohamed", comment: "Great place with serious services" },
  { name: "Oussama Manaii", comment: "Espace très favorable pour étudier. Bien équipé." },
  { name: "Skander Bedoui", comment: "Best space for studying ❤" },
  { name: "KENZA BOUAZIZI", comment: "Une atmosphère très agréable et conviviale ❤️" },
  { name: "Louay Chatti", comment: "Espace calme et parfait pour la révision" },
  { name: "Aziz Hamzoui", comment: "Espace agréable je recommande" },
  { name: "Rania Belhajd Nasser", comment: "Espace formidable" },
];

const FAQS = [
  { q: "Can I pause my session once I start?", a: "No — all passes run consecutively from the moment you check in. Please plan your sessions accordingly." },
  { q: "Can I upgrade or change my membership mid-cycle?", a: "Unfortunately memberships cannot be changed mid-cycle. For flexibility, consider shorter plans." },
  { q: "Can I stack multiple daily passes?", a: "Yes — you can purchase additional hours to extend your stay beyond your original pass." },
  { q: "Are there rules I must follow?", a: "Yes — all members must follow our official regulations.", link: { href: "/rules.pdf", label: "View the full rulebook ↗" } },
  { q: "Who can stay past midnight?", a: "Only approved university students are permitted after midnight. Eligibility depends on seniority and other factors reviewed by staff." },
  { q: "Do you serve food or drinks?", a: "We have a shared kitchen with coffee, snacks, water, energy drinks and more. Please keep the space clean." },
];

const AVATAR_COLORS = ["#111110", "#1d9e75", "#0077cc", "#6d28d9", "#b45309", "#be185d"];

// ─── HELPERS ─────────────────────────────────────────────────────────────────

const avatarColor = (name) => AVATAR_COLORS[name.charCodeAt(0) % AVATAR_COLORS.length];
const initials = (name) => name.split(" ").map((w) => w[0] || "").slice(0, 2).join("").toUpperCase();

// ─── STYLES ──────────────────────────────────────────────────────────────────

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Geist+Mono:wght@400;500&family=Plus+Jakarta+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&display=swap');

  :root {
    --bg: #fafaf9;
    --bg2: #ffffff;
    --bg3: #f4f4f2;
    --ink: #111110;
    --ink2: #6f6f69;
    --ink3: #a8a89e;
    --border: #e5e5e0;
    --border2: #d0d0c8;
    --cyan: #00d4d4;
    --cyan-dim: rgba(0,212,212,0.12);
    --cyan-glow: rgba(0,212,212,0.35);
    --r: 8px;
    --r2: 12px;
  }

  * { box-sizing: border-box; margin: 0; padding: 0; }
  html { scroll-behavior: smooth; }

  .ws-root {
    font-family: 'Plus Jakarta Sans', sans-serif;
    background: var(--bg);
    color: var(--ink);
    line-height: 1.6;
    overflow-x: hidden;
    font-size: 15px;
    min-height: 100vh;
  }

  /* GRID BG */
  .ws-grid-bg {
    position: fixed; inset: 0; z-index: 0; pointer-events: none;
    background-color: var(--bg);
    background-image:
      linear-gradient(rgba(0,0,0,0.045) 1px, transparent 1px),
      linear-gradient(90deg, rgba(0,0,0,0.045) 1px, transparent 1px);
    background-size: 32px 32px;
  }

  /* NAV */
  .ws-nav {
    position: fixed; top: 0; left: 0; right: 0; z-index: 200;
    height: 56px; display: flex; align-items: center; justify-content: space-between;
    padding: 0 32px;
    background: rgba(250,250,249,0.85);
    backdrop-filter: blur(16px);
    border-bottom: 1px solid var(--border);
  }
  .ws-nav-logo {
    font-family: 'Geist Mono', monospace; font-weight: 500; font-size: 0.95rem;
    letter-spacing: -0.01em; color: var(--ink); text-decoration: none;
  }
  .ws-nav-links { display: flex; gap: 2px; align-items: center; flex-wrap: wrap; }
  .ws-nav-links a {
    font-size: 0.8rem; color: var(--ink2); text-decoration: none;
    padding: 5px 10px; border-radius: 6px; transition: background 0.15s, color 0.15s; font-weight: 500;
  }
  .ws-nav-links a:hover { background: var(--bg3); color: var(--ink); }
  .ws-nav-sep { width: 1px; height: 16px; background: var(--border); margin: 0 6px; }

  /* HERO */
  .ws-hero {
    position: relative; z-index: 1;
    min-height: 100vh; display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    padding: 80px 24px 60px; text-align: center;
  }
  .ws-chip {
    display: inline-flex; align-items: center; gap: 7px;
    border: 1px solid var(--border2); border-radius: 999px;
    padding: 4px 14px 4px 8px; font-size: 0.73rem; font-weight: 600;
    color: var(--ink2); margin-bottom: 28px; background: var(--bg2);
    letter-spacing: 0.04em; text-transform: uppercase;
  }
  .ws-chip-dot {
    width: 6px; height: 6px; border-radius: 50%;
    background: var(--cyan); box-shadow: 0 0 6px var(--cyan);
  }
  .ws-hero h1 {
    font-size: clamp(2.6rem, 7vw, 5.5rem); font-weight: 700;
    letter-spacing: -0.04em; line-height: 1.05;
    color: var(--ink); margin-bottom: 22px; max-width: 820px;
  }
  .ws-hero-hl { color: var(--cyan); text-shadow: 0 0 32px var(--cyan-glow); }
  .ws-hero-sub {
    font-size: 1.05rem; font-weight: 400; color: var(--ink2);
    max-width: 500px; margin: 0 auto 36px; line-height: 1.7;
  }
  .ws-hero-btns { display: flex; gap: 10px; flex-wrap: wrap; justify-content: center; }

  /* BUTTONS */
  .ws-btn {
    display: inline-flex; align-items: center; gap: 7px;
    padding: 10px 22px; border-radius: var(--r);
    font-size: 0.85rem; font-weight: 600; cursor: pointer;
    text-decoration: none; transition: all 0.2s;
    font-family: 'Plus Jakarta Sans', sans-serif; border: none; letter-spacing: 0.01em;
  }
  .ws-btn-outline {
    background: transparent; border: 1px solid var(--border2); color: var(--ink);
  }
  .ws-btn-outline:hover { border-color: var(--border); background: var(--bg3); }
  .ws-btn-dark { background: var(--ink); color: #fff; }
  .ws-btn-dark:hover { background: #2a2a28; transform: translateY(-1px); }
  .ws-btn-cyan {
    position: relative; overflow: hidden;
    background: linear-gradient(135deg, #00cccc, #0088ff);
    color: #fff; box-shadow: 0 0 18px var(--cyan-glow);
    transition: transform 0.2s, box-shadow 0.2s;
  }
  .ws-btn-cyan:hover { transform: translateY(-1px) scale(1.02); box-shadow: 0 0 30px var(--cyan-glow); }
  .ws-btn-cyan::before {
    content: ''; position: absolute; inset: 0;
    background: radial-gradient(circle at 30% 50%, rgba(255,255,255,0.18), transparent 70%);
    pointer-events: none;
  }
  .ws-badge-new {
    background: #ef4444; color: #fff; font-size: 0.6rem; font-weight: 700;
    padding: 2px 6px; border-radius: 999px; letter-spacing: 0.08em;
    animation: wsBadgePulse 1.6s infinite;
  }
  @keyframes wsBadgePulse {
    0%, 100% { box-shadow: 0 0 4px rgba(239,68,68,0.7); }
    50% { box-shadow: 0 0 12px rgba(239,68,68,1); }
  }

  /* TICKER */
  .ws-ticker-wrap {
    position: relative; z-index: 1; overflow: hidden; padding: 14px 0;
    border-top: 1px solid var(--border); border-bottom: 1px solid var(--border);
    background: var(--bg2);
  }
  .ws-ticker-track {
    display: inline-flex; gap: 8px;
    animation: wsTickAnim 55s linear infinite; white-space: nowrap;
  }
  .ws-ticker-pill {
    display: inline-flex; align-items: center; gap: 6px;
    padding: 5px 14px; border-radius: 999px;
    border: 1px solid var(--border); background: var(--bg);
    font-size: 0.78rem; font-weight: 500; color: var(--ink2);
  }
  @keyframes wsTickAnim { from { transform: translateX(0); } to { transform: translateX(-50%); } }

  /* SECTION */
  .ws-section { position: relative; z-index: 1; padding: 80px 24px; }
  .ws-section-inner { max-width: 1100px; margin: 0 auto; }
  .ws-section-tag {
    font-family: 'Geist Mono', monospace; font-size: 0.72rem; font-weight: 500;
    letter-spacing: 0.1em; text-transform: uppercase; color: var(--ink3);
    margin-bottom: 10px; display: block;
  }
  .ws-section-title {
    font-size: clamp(1.6rem, 3.5vw, 2.4rem); font-weight: 700;
    letter-spacing: -0.03em; color: var(--ink); line-height: 1.15; margin-bottom: 14px;
  }
  .ws-section-sub { font-size: 0.95rem; color: var(--ink2); max-width: 460px; line-height: 1.7; }
  .ws-section-header {
    display: flex; justify-content: space-between; align-items: flex-end;
    gap: 32px; flex-wrap: wrap; margin-bottom: 48px;
  }

  /* FEATURES */
  .ws-feat-grid {
    display: grid; grid-template-columns: repeat(3, 1fr);
    gap: 1px; border: 1px solid var(--border); border-radius: var(--r2);
    overflow: hidden; background: var(--border);
  }
  .ws-feat-cell {
    background: var(--bg2); padding: 28px 24px; transition: background 0.2s;
  }
  .ws-feat-cell:hover { background: var(--bg3); }
  .ws-feat-cell.wide { grid-column: span 2; }
  .ws-feat-cell.dark { background: var(--ink); }
  .ws-feat-cell.dark:hover { background: #1a1a18; }
  .ws-feat-cell.cyan { background: var(--cyan-dim); }
  .ws-feat-icon { font-size: 1.4rem; margin-bottom: 12px; display: block; }
  .ws-feat-name { font-size: 0.9rem; font-weight: 600; color: var(--ink); margin-bottom: 5px; }
  .ws-feat-name.light { color: #fff; }
  .ws-feat-desc { font-size: 0.82rem; color: var(--ink2); line-height: 1.6; }
  .ws-feat-desc.light { color: rgba(255,255,255,0.5); }
  .ws-feat-stat {
    font-family: 'Geist Mono', monospace; font-size: 2.4rem;
    font-weight: 500; color: #fff; line-height: 1; margin-bottom: 4px;
  }
  .ws-feat-stat-label { font-size: 0.8rem; color: rgba(255,255,255,0.5); }

  /* ROOMS */
  .ws-rooms-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 16px; }
  .ws-room-card {
    border: 1px solid var(--border); border-radius: var(--r2);
    overflow: hidden; background: var(--bg2); transition: border-color 0.2s, transform 0.25s;
  }
  .ws-room-card:hover { border-color: var(--border2); transform: translateY(-2px); }
  .ws-room-thumb {
    height: 160px; display: flex; align-items: center;
    justify-content: center; font-size: 3.5rem;
  }
  .ws-room-body { padding: 22px; }
  .ws-room-top { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }
  .ws-room-name { font-size: 1rem; font-weight: 700; color: var(--ink); }
  .ws-room-cap {
    font-family: 'Geist Mono', monospace; font-size: 0.72rem; font-weight: 500;
    color: var(--ink2); background: var(--bg3); border: 1px solid var(--border);
    padding: 3px 10px; border-radius: 999px;
  }
  .ws-room-desc { font-size: 0.83rem; color: var(--ink2); margin-bottom: 14px; line-height: 1.65; }
  .ws-room-tags { display: flex; flex-wrap: wrap; gap: 5px; }
  .ws-tag {
    font-size: 0.72rem; font-weight: 500; padding: 3px 9px; border-radius: 999px;
    border: 1px solid var(--border); color: var(--ink2); background: var(--bg);
  }
  .ws-tag.red {
    border-color: rgba(239,68,68,0.25); background: rgba(239,68,68,0.06); color: #dc2626;
  }

  /* DIGITAL */
  .ws-digital { background: var(--ink) !important; }
  .ws-digital-inner {
    max-width: 1100px; margin: 0 auto;
    display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: center;
  }
  .ws-digital .ws-section-tag { color: rgba(255,255,255,0.35); }
  .ws-digital .ws-section-title { color: #fff; }
  .ws-digital .ws-section-sub { color: rgba(255,255,255,0.5); }
  .ws-digital-panel {
    border: 1px solid rgba(255,255,255,0.1); border-radius: var(--r2); overflow: hidden;
  }
  .ws-dp-row {
    display: flex; align-items: flex-start; gap: 14px;
    padding: 18px 20px; border-bottom: 1px solid rgba(255,255,255,0.07);
  }
  .ws-dp-row:last-child { border-bottom: none; }
  .ws-dp-icon {
    width: 36px; height: 36px; border-radius: 8px;
    background: rgba(0,212,212,0.15); display: flex; align-items: center;
    justify-content: center; font-size: 1rem; flex-shrink: 0;
  }
  .ws-dp-title { font-size: 0.88rem; font-weight: 600; color: #fff; margin-bottom: 3px; }
  .ws-dp-desc { font-size: 0.8rem; color: rgba(255,255,255,0.45); line-height: 1.55; }

  /* SDG */
  .ws-sdg-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; margin-top: 48px; }
  .ws-sdg-card {
    border: 1px solid var(--border); border-radius: var(--r2);
    padding: 24px 20px; background: var(--bg); transition: border-color 0.2s;
  }
  .ws-sdg-card:hover { border-color: var(--border2); }
  .ws-sdg-n {
    font-family: 'Geist Mono', monospace; font-size: 0.72rem; font-weight: 500;
    color: var(--ink3); margin-bottom: 8px; display: block;
  }
  .ws-sdg-card h3 { font-size: 0.88rem; font-weight: 700; color: var(--ink); margin-bottom: 8px; line-height: 1.3; }
  .ws-sdg-card p { font-size: 0.8rem; color: var(--ink2); line-height: 1.65; }

  /* PRICING */
  .ws-pricing-box { max-width: 680px; margin: 0 auto; }
  .ws-tab-bar {
    display: flex; background: var(--bg3); border: 1px solid var(--border);
    border-radius: var(--r); padding: 3px; margin-bottom: 24px;
  }
  .ws-tab-btn {
    flex: 1; padding: 8px; border: none; background: none;
    font-family: 'Plus Jakarta Sans', sans-serif; font-size: 0.82rem;
    font-weight: 600; color: var(--ink2); cursor: pointer; border-radius: 6px; transition: all 0.15s;
  }
  .ws-tab-btn.active { background: var(--bg2); color: var(--ink); box-shadow: 0 1px 3px rgba(0,0,0,0.08); }
  .ws-pricing-note {
    background: rgba(0,212,212,0.07); border: 1px solid rgba(0,212,212,0.2);
    border-radius: var(--r); padding: 12px 16px; font-size: 0.8rem;
    color: var(--ink2); margin-bottom: 20px; line-height: 1.6;
  }
  .ws-p-table { width: 100%; border-collapse: collapse; border: 1px solid var(--border); border-radius: var(--r2); overflow: hidden; }
  .ws-p-table th {
    background: var(--bg3); font-size: 0.73rem; font-weight: 700;
    letter-spacing: 0.07em; text-transform: uppercase; color: var(--ink3);
    padding: 11px 18px; text-align: left; border-bottom: 1px solid var(--border);
  }
  .ws-p-table td { padding: 14px 18px; border-bottom: 1px solid var(--border); font-size: 0.88rem; color: var(--ink); }
  .ws-p-table tr:last-child td { border-bottom: none; }
  .ws-p-table tr:hover td { background: var(--bg3); }
  .ws-p-price {
    font-family: 'Geist Mono', monospace; font-weight: 500; font-size: 0.95rem;
    color: var(--cyan); filter: drop-shadow(0 0 6px var(--cyan-glow));
  }

  /* REVIEWS */
  .ws-reviews-top {
    display: flex; justify-content: space-between; align-items: flex-end;
    flex-wrap: wrap; gap: 24px; margin-bottom: 40px;
  }
  .ws-rating-num {
    font-family: 'Geist Mono', monospace; font-size: 3rem;
    font-weight: 500; color: var(--ink); line-height: 1;
  }
  .ws-rating-stars { color: #f59e0b; font-size: 1rem; letter-spacing: 2px; margin: 4px 0; }
  .ws-rating-label { font-size: 0.78rem; color: var(--ink3); }
  .ws-review-masonry { columns: 4; column-gap: 14px; }
  .ws-rv-card {
    break-inside: avoid; margin-bottom: 14px; border: 1px solid var(--border);
    border-radius: var(--r2); padding: 18px; background: var(--bg); transition: border-color 0.2s;
  }
  .ws-rv-card:hover { border-color: var(--border2); }
  .ws-rv-top { display: flex; align-items: center; gap: 10px; margin-bottom: 10px; }
  .ws-rv-av {
    width: 30px; height: 30px; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    font-size: 0.7rem; font-weight: 700; color: #fff; flex-shrink: 0;
  }
  .ws-rv-name { font-size: 0.83rem; font-weight: 600; color: var(--ink); }
  .ws-rv-stars { color: #f59e0b; font-size: 0.7rem; letter-spacing: 1px; }
  .ws-rv-comment { font-size: 0.8rem; color: var(--ink2); line-height: 1.65; }
  .ws-reviews-more { text-align: center; margin-top: 28px; }

  /* DIRECTIONS */
  .ws-dir-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; margin-top: 40px; }
  .ws-dir-card {
    border: 1px solid var(--border); border-radius: var(--r2);
    padding: 24px 20px; background: var(--bg2);
  }
  .ws-dir-em { font-size: 1.6rem; margin-bottom: 12px; display: block; }
  .ws-dir-title { font-size: 0.9rem; font-weight: 700; color: var(--ink); margin-bottom: 8px; }
  .ws-dir-text { font-size: 0.82rem; color: var(--ink2); line-height: 1.65; }
  .ws-dir-text a { color: var(--cyan); text-decoration: none; }

  /* FAQ */
  .ws-faq-inner { max-width: 700px; margin: 0 auto; }
  .ws-faq-item { border-bottom: 1px solid var(--border); }
  .ws-faq-q {
    width: 100%; display: flex; justify-content: space-between; align-items: center;
    padding: 18px 0; background: none; border: none;
    font-family: 'Plus Jakarta Sans', sans-serif; font-size: 0.9rem; font-weight: 600;
    color: var(--ink); cursor: pointer; text-align: left; gap: 16px;
  }
  .ws-faq-ico { color: var(--ink3); font-size: 1.1rem; transition: transform 0.22s; flex-shrink: 0; }
  .ws-faq-ico.open { transform: rotate(45deg); }
  .ws-faq-a {
    font-size: 0.85rem; color: var(--ink2); line-height: 1.75;
    overflow: hidden; transition: max-height 0.3s ease, padding 0.2s;
  }
  .ws-faq-a a { color: var(--cyan); }

  /* FOOTER */
  .ws-footer {
    background: var(--ink); color: rgba(255,255,255,0.6);
    padding: 52px 32px 28px; position: relative; z-index: 1;
  }
  .ws-ft { max-width: 1100px; margin: 0 auto; }
  .ws-ft-top {
    display: grid; grid-template-columns: 2fr 1fr 1fr; gap: 48px;
    padding-bottom: 36px; border-bottom: 1px solid rgba(255,255,255,0.08); margin-bottom: 28px;
  }
  .ws-ft-logo {
    font-family: 'Geist Mono', monospace; font-size: 0.9rem;
    font-weight: 500; color: #fff; margin-bottom: 10px; display: block;
  }
  .ws-ft-tagline { font-size: 0.82rem; color: rgba(255,255,255,0.4); line-height: 1.7; }
  .ws-ft-col h4 {
    font-size: 0.7rem; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase;
    color: rgba(255,255,255,0.3); margin-bottom: 14px; font-family: 'Geist Mono', monospace;
  }
  .ws-ft-col ul { list-style: none; }
  .ws-ft-col ul li { margin-bottom: 8px; }
  .ws-ft-col ul li a { font-size: 0.82rem; color: rgba(255,255,255,0.55); text-decoration: none; transition: color 0.15s; }
  .ws-ft-col ul li a:hover { color: #fff; }
  .ws-ft-bottom { display: flex; justify-content: space-between; flex-wrap: wrap; gap: 10px; }
  .ws-ft-bottom p { font-size: 0.75rem; color: rgba(255,255,255,0.3); }

  /* RESPONSIVE */
  @media (max-width: 1024px) {
    .ws-feat-grid { grid-template-columns: repeat(2, 1fr); }
    .ws-feat-cell.wide { grid-column: span 1; }
    .ws-rooms-grid { grid-template-columns: 1fr; }
    .ws-digital-inner { grid-template-columns: 1fr; gap: 36px; }
    .ws-sdg-grid { grid-template-columns: repeat(2, 1fr); }
    .ws-review-masonry { columns: 3; }
    .ws-dir-grid { grid-template-columns: 1fr; }
    .ws-ft-top { grid-template-columns: 1fr 1fr; gap: 28px; }
  }
  @media (max-width: 768px) {
    .ws-nav { padding: 0 16px; }
    .ws-nav-links { display: none; }
    .ws-section { padding: 56px 16px; }
    .ws-feat-grid { grid-template-columns: 1fr; }
    .ws-sdg-grid { grid-template-columns: 1fr 1fr; }
    .ws-review-masonry { columns: 2; }
    .ws-ft-top { grid-template-columns: 1fr; }
  }
  @media (max-width: 480px) {
    .ws-review-masonry { columns: 1; }
    .ws-sdg-grid { grid-template-columns: 1fr; }
  }
`;

// ─── SUB-COMPONENTS ──────────────────────────────────────────────────────────

function Ticker() {
  const items = [...TICKER_ITEMS, ...TICKER_ITEMS, ...TICKER_ITEMS, ...TICKER_ITEMS];
  return (
    <div className="ws-ticker-wrap">
      <div className="ws-ticker-track">
        {items.map(([icon, label], i) => (
          <span key={i} className="ws-ticker-pill">
            <span>{icon}</span>{label}
          </span>
        ))}
      </div>
    </div>
  );
}

function FeatCell({ f }) {
  if (f.stat) {
    return (
      <div className="ws-feat-cell dark">
        <div className="ws-feat-stat">{f.stat}</div>
        <div className="ws-feat-stat-label">{f.label}</div>
      </div>
    );
  }
  const cls = ["ws-feat-cell", f.wide ? "wide" : "", f.cyan ? "cyan" : ""].filter(Boolean).join(" ");
  return (
    <div className={cls}>
      <span className="ws-feat-icon">{f.icon}</span>
      <div className="ws-feat-name">{f.name}</div>
      <div className="ws-feat-desc">{f.desc}</div>
    </div>
  );
}

function RoomCard({ room }) {
  return (
    <div className="ws-room-card">
      <div className="ws-room-thumb" style={{ background: room.bg }}>{room.icon}</div>
      <div className="ws-room-body">
        <div className="ws-room-top">
          <span className="ws-room-name">{room.name}</span>
          <span className="ws-room-cap">{room.capacity} seats</span>
        </div>
        <p className="ws-room-desc">{room.desc}</p>
        <div className="ws-room-tags">
          {room.tags.map((t, i) => (
            <span key={i} className={`ws-tag${t.red ? " red" : ""}`}>{t.label}</span>
          ))}
        </div>
      </div>
    </div>
  );
}

function PricingTable({ rows, colLabel }) {
  return (
    <table className="ws-p-table">
      <thead>
        <tr>
          <th>{colLabel}</th>
          <th>Price</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={i}>
            <td>{r.duration}</td>
            <td><span className="ws-p-price">{r.price}</span></td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function ReviewCard({ review }) {
  return (
    <div className="ws-rv-card">
      <div className="ws-rv-top">
        <div className="ws-rv-av" style={{ background: avatarColor(review.name) }}>
          {initials(review.name)}
        </div>
        <div>
          <div className="ws-rv-name">{review.name}</div>
          <div className="ws-rv-stars">★★★★★</div>
        </div>
      </div>
      {review.comment && <div className="ws-rv-comment">{review.comment}</div>}
    </div>
  );
}

function FaqItem({ faq }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="ws-faq-item">
      <button className="ws-faq-q" onClick={() => setOpen(!open)}>
        {faq.q}
        <span className={`ws-faq-ico${open ? " open" : ""}`}>+</span>
      </button>
      <div className="ws-faq-a" style={{ maxHeight: open ? 240 : 0, paddingBottom: open ? 18 : 0 }}>
        {faq.a}
        {faq.link && <> <a href={faq.link.href} target="_blank" rel="noopener noreferrer">{faq.link.label}</a></>}
      </div>
    </div>
  );
}

// ─── MAIN COMPONENT ──────────────────────────────────────────────────────────

export default function WeStudyHome() {
  const [activeTab, setActiveTab] = useState("daily");
  const [showAll, setShowAll] = useState(false);
  const INIT_REVIEWS = 8;

  const visibleReviews = showAll ? REVIEWS : REVIEWS.slice(0, INIT_REVIEWS);
  const tabColLabel = { daily: "Duration", weekly: "Daily Duration", monthly: "Daily Duration" };

  return (
    <>
      <style>{css}</style>
      <div className="ws-root">
        <div className="ws-grid-bg" />

       {/* NAV */}
<nav className="ws-nav">
  <a href="#" className="ws-nav-logo">
    <img src="/logogo.png" alt="WeStudy" style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover", marginRight: 8, verticalAlign: "middle" }} />
    WeStudy
  </a>
  <div className="ws-nav-links">
    {["features", "rooms", "digital", "impact", "pricing", "reviews", "faq"].map((s) => (
      <a key={s} href={`#${s}`}>{s.charAt(0).toUpperCase() + s.slice(1)}</a>
    ))}
    <span className="ws-nav-sep" />
    <a href="https://forms.fillout.com/t/mDoNqvNVd5us" target="_blank" rel="noopener noreferrer">Careers</a>
  </div>
</nav>

        {/* HERO */}
     <div className="ws-hero">
  <img src="/logogo.png" alt="WeStudy" style={{ width: 180, height: 180,  objectFit: "cover", marginBottom: 24 }} />
  <span className="ws-chip"><span className="ws-chip-dot" />Open 24/7 · Ezzahra, Saint Germain</span>
  <h1>Study Smarter.<br />Focus <span className="ws-hero-hl">Deeper.</span></h1>
  <p className="ws-hero-sub">Banlieue Sud's premier co-studying space — a calm, equipped environment designed for every student, every hour of the day.</p>
  <div className="ws-hero-btns">
    <a href="#digital" className="ws-btn ws-btn-cyan">WeStudy Digital <span className="ws-badge-new">NEW</span></a>
    <a href="#pricing" className="ws-btn ws-btn-dark">View Pricing</a>
    <a href="#features" className="ws-btn ws-btn-outline">Explore Features</a>
  </div>
</div>

        {/* TICKER */}
        <Ticker />

        {/* FEATURES */}
        <div className="ws-section" id="features" style={{ background: "var(--bg2)" }}>
          <div className="ws-section-inner">
            <div className="ws-section-header">
              <div>
                <span className="ws-section-tag">What's inside</span>
                <h2 className="ws-section-title">Everything you need<br />to do your best work</h2>
              </div>
              <p className="ws-section-sub">Comfort, focus, and convenience — all in one space. We handle the logistics so you can concentrate on what matters.</p>
            </div>
            <div className="ws-feat-grid">
              {FEATURES.map((f, i) => <FeatCell key={i} f={f} />)}
            </div>
          </div>
        </div>

        {/* ROOMS */}
        <div className="ws-section" id="rooms">
          <div className="ws-section-inner">
            <div className="ws-section-header">
              <div>
                <span className="ws-section-tag">Study Rooms</span>
                <h2 className="ws-section-title">Four zones.<br />One mission.</h2>
              </div>
              <p className="ws-section-sub">Each room has its own atmosphere and ruleset — pick the environment that matches your focus level today.</p>
            </div>
            <div className="ws-rooms-grid">
              {ROOMS.map((r, i) => <RoomCard key={i} room={r} />)}
            </div>
          </div>
        </div>

        {/* DIGITAL */}
        <div className="ws-section ws-digital" id="digital">
          <div className="ws-digital-inner">
            <div>
              <span className="ws-section-tag">WeStudy Digital</span>
              <h2 className="ws-section-title">Not just a space.<br />A platform.</h2>
              <p className="ws-section-sub" style={{ marginBottom: 28 }}>We're building the full productivity stack for students — AI tools, smart booking, real-time analytics, and a loyalty system built around your study habits.</p>
              <a href="#" className="ws-btn ws-btn-cyan">Discover the Platform</a>
            </div>
            <div className="ws-digital-panel">
              {DIGITAL_FEATURES.map((f, i) => (
                <div key={i} className="ws-dp-row">
                  <div className="ws-dp-icon">{f.icon}</div>
                  <div>
                    <div className="ws-dp-title">{f.title}</div>
                    <div className="ws-dp-desc">{f.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* SDG IMPACT */}
        <div className="ws-section" id="impact" style={{ background: "var(--bg2)" }}>
          <div className="ws-section-inner">
            <div style={{ textAlign: "center", maxWidth: 560, margin: "0 auto" }}>
              <span className="ws-section-tag">Global Impact</span>
              <h2 className="ws-section-title">WeStudy & the UN Goals</h2>
              <p className="ws-section-sub" style={{ margin: "0 auto" }}>We align our mission with United Nations Sustainable Development Goals — because a study space can be a genuine force for good.</p>
            </div>
            <div className="ws-sdg-grid">
              {SDGS.map((s, i) => (
                <div key={i} className="ws-sdg-card">
                  <span className="ws-sdg-n">SDG {s.num}</span>
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* PRICING */}
        <div className="ws-section" id="pricing">
          <div className="ws-section-inner">
            <div className="ws-section-header" style={{ marginBottom: 36 }}>
              <div>
                <span className="ws-section-tag">Pricing</span>
                <h2 className="ws-section-title">Simple. Transparent.<br />No surprises.</h2>
              </div>
              <p className="ws-section-sub">From a quick 2-hour drop-in to a full monthly membership — choose what works for you today.</p>
            </div>
            <div className="ws-pricing-box">
              <div className="ws-tab-bar">
                {["daily", "weekly", "monthly"].map((tab) => (
                  <button
                    key={tab}
                    className={`ws-tab-btn${activeTab === tab ? " active" : ""}`}
                    onClick={() => setActiveTab(tab)}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)} Pass
                  </button>
                ))}
              </div>
              <div className="ws-pricing-note">
                <strong>Heads up:</strong> Hours run consecutively from check-in — a 5h pass is 5 straight hours, not spread across the day.
              </div>
              <PricingTable rows={PRICING[activeTab]} colLabel={tabColLabel[activeTab]} />
            </div>
          </div>
        </div>

        {/* REVIEWS */}
        <div className="ws-section" id="reviews" style={{ background: "var(--bg2)" }}>
          <div className="ws-section-inner">
            <div className="ws-reviews-top">
              <div>
                <span className="ws-section-tag">Member reviews</span>
                <h2 className="ws-section-title">Loved by 1,500+ students</h2>
              </div>
              <div style={{ textAlign: "right" }}>
                <div className="ws-rating-num">5.0</div>
                <div className="ws-rating-stars">★★★★★</div>
                <div className="ws-rating-label">Google Reviews average</div>
              </div>
            </div>
            <div className="ws-review-masonry">
              {visibleReviews.map((r, i) => <ReviewCard key={i} review={r} />)}
            </div>
            <div className="ws-reviews-more">
              <button className="ws-btn ws-btn-outline" onClick={() => setShowAll(!showAll)}>
                {showAll ? "Show less" : "Show all reviews"}
              </button>
            </div>
          </div>
        </div>

        {/* DIRECTIONS */}
        <div className="ws-section" id="directions">
          <div className="ws-section-inner">
            <span className="ws-section-tag">Find us</span>
            <h2 className="ws-section-title">Getting here is easy</h2>
            <div className="ws-dir-grid">
              <div className="ws-dir-card">
                <span className="ws-dir-em">🚆</span>
                <div className="ws-dir-title">By Train</div>
                <p className="ws-dir-text">Alight at <strong>Ezzahra Station</strong>, take Exit 1, walk 4 minutes to Farhat Hached Avenue.</p>
              </div>
              <div className="ws-dir-card">
                <span className="ws-dir-em">🚌</span>
                <div className="ws-dir-title">By Bus</div>
                <p className="ws-dir-text">Bus 37, 37/10, or 39 — get off at <strong>Kiosk Total</strong>, then walk to Rond Point Kamanja (~10 min).</p>
              </div>
              <div className="ws-dir-card">
                <span className="ws-dir-em">🚗</span>
                <div className="ws-dir-title">By Car</div>
                <p className="ws-dir-text">
                  <a className="ws-dir-text" href="https://www.google.com/maps/place/Westudy+Saint+Germain+Co-Studying+Space/@36.7466226,10.305259" target="_blank" rel="noopener noreferrer" style={{ color: "var(--cyan)" }}>Open in Google Maps ↗</a>
                  {" "}— parking available on Farhat Hached Avenue.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ */}
        <div className="ws-section" id="faq" style={{ background: "var(--bg2)" }}>
          <div className="ws-section-inner">
            <div className="ws-section-header" style={{ marginBottom: 36 }}>
              <div>
                <span className="ws-section-tag">FAQ</span>
                <h2 className="ws-section-title">Frequently asked questions</h2>
              </div>
            </div>
            <div className="ws-faq-inner">
              {FAQS.map((f, i) => <FaqItem key={i} faq={f} />)}
            </div>
          </div>
        </div>

        {/* CAREERS */}
        <div className="ws-section" id="careers" style={{ textAlign: "center" }}>
          <div style={{ maxWidth: 600, margin: "0 auto" }}>
            <span className="ws-section-tag">Join us</span>
            <h2 className="ws-section-title" style={{ marginBottom: 14 }}>Work where students thrive</h2>
            <p className="ws-section-sub" style={{ margin: "0 auto 30px" }}>Looking for a part-time role in a productive, vibrant space? We're always looking for motivated people.</p>
            <a href="https://forms.fillout.com/t/mDoNqvNVd5us" target="_blank" rel="noopener noreferrer" className="ws-btn ws-btn-dark">Apply Now →</a>
          </div>
        </div>

        {/* FOOTER */}
        <footer className="ws-footer">
          <div className="ws-ft">
            <div className="ws-ft-top">
              <div>
                <span className="ws-ft-logo">WeStudy</span>
                <p className="ws-ft-tagline">Empowering focus and motivation since December 2021.<br />187 m² · 57 workstations · 4 zones · Open 24/7 · Tunis</p>
              </div>
              <div className="ws-ft-col">
                <h4>Explore</h4>
                <ul>
                  {["features", "rooms", "digital", "pricing", "reviews", "faq"].map((s) => (
                    <li key={s}><a href={`#${s}`}>{s.charAt(0).toUpperCase() + s.slice(1)}</a></li>
                  ))}
                </ul>
              </div>
              <div className="ws-ft-col">
                <h4>Connect</h4>
                <ul>
                  <li><a href="mailto:contact@westudy.tn">contact@westudy.tn</a></li>
                  <li><a href="tel:+21670550013">+216 70 550 013</a></li>
                  <li><a href="https://www.instagram.com/westudy_sg_costudyingspace/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
                  <li><a href="https://www.facebook.com/WeStudySG" target="_blank" rel="noopener noreferrer">Facebook</a></li>
                  <li><a href="https://www.google.com/maps/place/Westudy+Saint+Germain+Co-Studying+Space" target="_blank" rel="noopener noreferrer">Google Maps</a></li>
                </ul>
              </div>
            </div>
            <div className="ws-ft-bottom">
              <p>© {new Date().getFullYear()} WeStudy. All rights reserved.</p>
              <p>Tunis, Tunisia · Est. 2021</p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}